import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer, NodeViewWrapper } from "@tiptap/react";
import { Plugin } from "@tiptap/pm/state";
function LockedClauseView({ node }) {
  return (
    <NodeViewWrapper
      className="
        my-4 rounded-xl border border-orange-200
        bg-orange-50 p-4 relative
      "
      onCut={(e) => e.preventDefault()} // 🔥 block cut
      onCopy={(e) => e.stopPropagation()}
      contentEditable={false} // 🔥 THIS BLOCKS ALL EDITING
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-2">
        <div className="text-sm font-semibold text-orange-700">
          🔒 {node.attrs.title}
        </div>

        <span className="text-[11px] bg-orange-200 text-orange-800 px-2 py-0.5 rounded-full">
          Locked
        </span>
      </div>

      {/* Content (read-only) */}
      <div className="text-sm text-gray-700 leading-6">{node.attrs.value}</div>
    </NodeViewWrapper>
  );
}

export const LockedClause = Node.create({
  name: "lockedClause",

  group: "block",

  atom: false, // 🔥 IMPORTANT (prevents selection/edit split)
  selectable: false, // 🔥 prevents selecting it for deletion
  draggable: false,

  addAttributes() {
    return {
      title: "",
      value: "",
      locked: true,
    };
  },

  parseHTML() {
    return [{ tag: "locked-clause" }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["locked-clause", mergeAttributes(HTMLAttributes), 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(LockedClauseView);
  },
addProseMirrorPlugins() {
  return [
    new Plugin({
      filterTransaction(tr) {
        // allow ALL normal edits
        return true;
      },
    }),
  ];
},
 addKeyboardShortcuts() {
  return {
    Enter: () => true,
  //  Backspace: () => true,
    Delete: () => true,
  };
}
});
